import React from "react";
import { Paper, Typography, Box, Chip } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import default_theme from "assets/themes/themes";
import { Button } from "@mui/material";
import TokenManager from "utils/tokenManager";

const DocumentItem = ({ title, file, highlight = false, comingSoon = false }) => {
  const handleDownload = async () => {
    try {
      const token = TokenManager.getAccessToken();
      if (!token) throw new Error("User not authenticated");

      // 1. Securely fetch the file using the Bearer header
      const response = await fetch(file, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to download: ${response.status}`);
      }

      // 2. Convert to a Blob (raw file data)
      const blob = await response.blob();
      const localUrl = window.URL.createObjectURL(blob);

      // 3. Create an invisible link to trigger the browser's download prompt
      const link = document.createElement("a");
      link.href = localUrl;
      link.download = title || "document"; // Uses the title prop as the filename
      document.body.appendChild(link);
      link.click();
      
      // 4. Clean up memory
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(localUrl);

    } catch (error) {
      console.error("Download failed:", error);
      alert("Could not download the file securely.");
    }
  };
  return (
    <Paper
      sx={{
        p: 2.5,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: "10px",
        opacity: comingSoon ? 0.6 : 1,
        ...(highlight && {
          backgroundColor: "rgba(53, 179, 171, 0.08)",
          border: "1px solid rgba(53, 179, 171, 0.4)",
          boxShadow: "0 4px 16px rgba(53, 179, 171, 0.14)",
        }),
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        {highlight && (
          <Chip
            label="Main document"
            size="small"
            sx={{
              backgroundColor: default_theme.palette.other.figmaBlue,
              color: "#fff",
              fontWeight: 600,
            }}
          />
        )}
        <Typography
          sx={{
            fontWeight: highlight ? 600 : 500,
            color: "#23576B",
          }}
        >
          {title}
        </Typography>
        {comingSoon && (
          <Chip
            label="Coming soon"
            size="small"
            sx={{
              backgroundColor: "#f0f0f0",
              color: "#999",
              fontWeight: 600,
              fontSize: "0.7rem",
            }}
          />
        )}
      </Box>

      <Button
        variant="contained"
        startIcon={<DownloadIcon />}
        disabled={comingSoon}
        onClick={handleDownload}
        sx={{
          backgroundColor: default_theme.palette.other.addButtonBlue,
          color: "#fff",
          "&:hover": {
            backgroundColor: default_theme.palette.other.figmaBlue,
            opacity: 0.9,
          },
        }}
      >
        Download
      </Button>
    </Paper>
  );
};

export default DocumentItem;